import { render, staticRenderFns } from "./ScriptObjectDrawer.vue?vue&type=template&id=5d3bad0d&"
import script from "./ScriptObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./ScriptObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports